var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStats60(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 30C25.5282 30 24.7019 29.6596 24.0212 28.9788C23.3404 28.2981 23 27.4718 23 26.5V21.6924C23 20.7206 23.3404 19.8943 24.0212 19.2136C24.7019 18.5328 25.5282 18.1924 26.5 18.1924C27.4718 18.1924 28.2981 18.5328 28.9788 19.2136C29.6596 19.8943 30 20.7206 30 21.6924V26.5C30 27.4718 29.6596 28.2981 28.9788 28.9788C28.2981 29.6596 27.4718 30 26.5 30ZM15 30C14.0282 30 13.2019 29.6596 12.5212 28.9788C11.8404 28.2981 11.5 27.4718 11.5 26.5V3.50001C11.5 2.52821 11.8404 1.70192 12.5212 1.02116C13.2019 0.340386 14.0282 0 15 0C15.9718 0 16.7981 0.340386 17.4788 1.02116C18.1596 1.70192 18.5 2.52821 18.5 3.50001V26.5C18.5 27.4718 18.1596 28.2981 17.4788 28.9788C16.7981 29.6596 15.9718 30 15 30ZM3.50001 30C2.52821 30 1.70192 29.6596 1.02115 28.9788C0.340384 28.2981 0 27.4718 0 26.5V13.3077C0 12.3359 0.340384 11.5097 1.02115 10.8289C1.70192 10.1481 2.52821 9.80773 3.50001 9.80773C4.47178 9.80773 5.29805 10.1481 5.97882 10.8289C6.65959 11.5097 6.99997 12.3359 6.99997 13.3077V26.5C6.99997 27.4718 6.65959 28.2981 5.97882 28.9788C5.29805 29.6596 4.47178 30 3.50001 30Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats60);
export default __webpack_public_path__ + "static/media/stats60.f2747759405987ce06cab19b2117d5aa.svg";
export { ForwardRef as ReactComponent };